import { UAParser } from 'ua-parser-js';
import safeStorage from './safeStorage';

/**
 * Generate or retrieve session ID
 */

const safeSession = {
  getItem: (k) => { try { return sessionStorage.getItem(k); } catch(e) { return null; } },
  setItem: (k, v) => { try { sessionStorage.setItem(k, v); } catch(e) {} },
  removeItem: (k) => { try { sessionStorage.removeItem(k); } catch(e) {} },
};

export const getSessionId = () => {
  let sessionId = safeSession.getItem('analytics_session_id');
  
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    safeSession.setItem('analytics_session_id', sessionId);
  }
  
  return sessionId;
};

/**
 * Parse UTM parameters from URL
 */
export const getUtmParams = () => {
  const params = new URLSearchParams(window.location.search);
  
  return {
    utmSource: params.get('utm_source'),
    utmMedium: params.get('utm_medium'),
    utmCampaign: params.get('utm_campaign'),
    utmTerm: params.get('utm_term'),
    utmContent: params.get('utm_content')
  };
};

/**
 * Parse user agent information
 */
export const getUserAgentInfo = () => {
  const parser = new UAParser();
  const result = parser.getResult();
  
  return {
    userAgent: navigator.userAgent,
    browserName: result.browser.name,
    browserVersion: result.browser.version,
    deviceType: result.device.type || 'desktop', // 'mobile', 'tablet', 'desktop'
    operatingSystem: `${result.os.name} ${result.os.version}`.trim()
  };
};

/**
 * Get referrer information
 */
export const getReferrerInfo = () => {
  const referrer = document.referrer;
  
  if (!referrer) {
    return { referrer: null, referrerType: 'direct' };
  }
  
  const currentDomain = window.location.hostname;
  const referrerUrl = new URL(referrer);
  
  // Check if internal or external referrer
  const isInternal = referrerUrl.hostname === currentDomain;
  
  return {
    referrer: referrer,
    referrerType: isInternal ? 'internal' : 'external',
    referrerDomain: referrerUrl.hostname
  };
};

/**
 * Build complete analytics context
 */
export const buildAnalyticsContext = (masterPageId, childPageId) => {
  const utmParams = getUtmParams();
  const userAgentInfo = getUserAgentInfo();
  const referrerInfo = getReferrerInfo();
  
  return {
    masterPageId,
    childPageId,
    sessionId: getSessionId(),
    ...utmParams,
    ...userAgentInfo,
    ...referrerInfo,
    pageUrl: decodeURI(window.location.href),
    pageTitle: document.title,
    viewedAt: new Date().toISOString()
  };
};